<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates1">
<p class="centerImage"><img alt="images" id="plate1" src="images/plate1.jpg"/></p>
<p class="caption">Starting out in life</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates1.vue?6245f851